module.exports = __webpack_public_path__ + "img/home-delivery.4403cfbb.webp";